import * as React from "react";
import type { SVGProps } from "react";
const SvgIcProductBundle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#040747"
      fillRule="evenodd"
      d="M7.363 7.098a.97.97 0 0 0-.993 0L2.723 9.254l4.141 2.452 4.143-2.453zm-5.228 7.507v-4.357L6.3 12.715v4.937l-3.667-2.166a1.02 1.02 0 0 1-.497-.88m4.844 4.383c.33-.017.657-.114.952-.289l3.738-2.208a2.19 2.19 0 0 0 1.064-1.886v-4.418c0-.778-.406-1.497-1.064-1.886L7.93 6.092a2.09 2.09 0 0 0-2.129 0l-3.737 2.21A2.19 2.19 0 0 0 1 10.186v4.418a2.19 2.19 0 0 0 1.064 1.886l3.738 2.208c.295.175.622.272.952.29a.6.6 0 0 0 .225 0m.455-1.337v-4.94l4.164-2.466v4.36c0 .362-.19.698-.497.88z"
      clipRule="evenodd"
    />
    <path
      fill="#040747"
      fillRule="evenodd"
      d="M17.63 7.098a.97.97 0 0 0-.993 0L12.99 9.254l4.14 2.452 4.144-2.453zm-5.228 7.507v-4.356l4.163 2.465v4.937L12.9 15.485a1.02 1.02 0 0 1-.497-.88m4.844 4.384a2.1 2.1 0 0 0 .952-.29l3.738-2.208A2.19 2.19 0 0 0 23 14.605v-4.418c0-.778-.406-1.497-1.065-1.886l-3.737-2.209a2.09 2.09 0 0 0-2.13 0l-3.736 2.21a2.19 2.19 0 0 0-1.065 1.885v4.418a2.19 2.19 0 0 0 1.064 1.886l3.738 2.208c.295.175.622.272.951.29a.6.6 0 0 0 .226 0m.455-1.338v-4.94l4.163-2.466v4.36c0 .362-.189.698-.497.88z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIcProductBundle;
